import { Link, NavLink } from "react-router-dom";
import { X } from "lucide-react";
import Layout from "../layout/Layout";
import BrandLogo from "../../components/brand/BrandLogo";

/**
 * Shell commun Login / Register — design léger Chinexpress.
 */
const Auth = ({ children, title, subtitle }) => {
  return (
    <Layout>
      <div className="min-h-screen bg-gradient-to-b from-orange-50 via-white to-gray-50">
        <div className="flex justify-end px-4 pt-4">
          <Link
            to="/"
            className="w-10 h-10 rounded-full bg-white border border-gray-100 shadow-sm flex items-center justify-center text-gray-500 active:bg-gray-50"
            aria-label="Fermer"
          >
            <X className="w-5 h-5" />
          </Link>
        </div>

        <div className="px-6 pt-2 pb-6 flex flex-col items-center">
          <div className="mb-4">
            <BrandLogo className="h-8" />
          </div>
          <h1 className="text-xl font-bold text-gray-900 text-center">
            {title || "Chinexpress"}
          </h1>
          {subtitle && (
            <p className="text-sm text-gray-500 text-center mt-1.5 max-w-xs leading-relaxed">
              {subtitle}
            </p>
          )}
        </div>

        <div className="mx-4 mb-4 flex p-1 bg-white rounded-xl border border-gray-100 shadow-sm">
          <NavLink
            to="/register"
            className={({ isActive }) =>
              `flex-1 text-center text-sm font-semibold py-2.5 rounded-lg transition-colors ${
                isActive
                  ? "bg-orange-500 text-white shadow-sm"
                  : "text-gray-500 hover:text-gray-700"
              }`
            }
          >
            S&apos;inscrire
          </NavLink>
          <NavLink
            to="/login"
            className={({ isActive }) =>
              `flex-1 text-center text-sm font-semibold py-2.5 rounded-lg transition-colors ${
                isActive
                  ? "bg-orange-500 text-white shadow-sm"
                  : "text-gray-500 hover:text-gray-700"
              }`
            }
          >
            Se connecter
          </NavLink>
        </div>

        <div className="px-4 pb-10">{children}</div>
      </div>
    </Layout>
  );
};

export default Auth;
